<template>
  <div class="service">
    <div class="content">
      <div class="kf-box">
        <p>客服服务时间为 09:00-22:00</p>
      </div>
      <h3 class="title">常见问题</h3>
      <div class="question-box">
        <van-collapse v-model="state.activeNames" :border="false">
          <van-collapse-item title="下载游戏" name="1">
            如果您有需要下载的游戏，可以通过在APP首页的搜索框进行输入游戏名称进行下载
          </van-collapse-item>
          <van-collapse-item title="无法登陆游戏" name="2">
            无法登录有以下几种情况：
            （1）游戏维护，服务器出现异常等都可能导致无法登录，请您耐心等待即可，
            （2）有可能是网络原因或者设备运行不畅导致的，建议您可以稍后尝试“清理手机缓存和游戏数据、重启手机、切换网络（wifi、4g）”再登录一下，
            （3）账号被封，可联系客服为您反馈处理。
          </van-collapse-item>
          <van-collapse-item title="如何折扣充值" name="3">
            目前平台内的折扣是由游戏方进行提供，您可以留意一下APP内游戏专区的折扣显示情况，有显示折扣的游戏可以通过进入游戏点击支付界面进行享受折扣充值。
          </van-collapse-item>
          <van-collapse-item title="游戏下载不了" name="4">
            如果出现游戏无法下载的情况
            （1）您可以通过以下链接进行重装0.1折手游APP进行下载游戏
            （2）如果使用IOS设备，可以点击人工客服联系客服咨询
          </van-collapse-item>
          <van-collapse-item title="游戏角色不见了" name="5">
            游戏角色不见可从以下几个方面检查下： （1）登错帐号、登错服务器；
            （2）安卓和ios系统两者的数据是不互通的
            （3）下载错游戏，平台上该游戏存在多个版本。您当前下载的版本和原来的不一致。
          </van-collapse-item>
          <van-collapse-item title="游戏开服时间" name="6">
            可以在APP首页搜索游戏名，在游戏专区可以查看对应开服表。如APP上没有显示相应开服信息，代表游戏厂商暂未提供最新开服信息，并且开服表仅作参考，游戏厂商可能会有临时变动，实际的开服情况请以游戏内的区服列表或公告为准。
          </van-collapse-item>
          <van-collapse-item title="游戏闪退怎么办" name="7">
            游戏闪退有以下情况， IOS用户： 请您删掉之前的游戏，重新打开APP下载，
            安卓用户： （1）游戏内存不足，关掉多余的后台应用
            （2）游戏异常，请联系在线客服进行反馈
          </van-collapse-item>

          <van-collapse-item title="如何申请游戏福利（返利道具等）" name="8">
            点击游戏内悬浮框→点击联系客服复制角色信息→角色信息发给平台客服备注您要申请的活动【需带上活动截图】
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>

      <div class="kf-btn-box">
        <div class="kf-btn" @click="onPhone()">在线客服</div>
      
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { reactive, onMounted } from "vue";
import { useStore } from "vuex";
import { getBoxSetting } from "../../api/user";
import { getQueryString } from "@/utils/location";
export default {
  name: "service",
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      activeNames: ["1"],
      wxUrl: "",
    });

    onMounted(() => {
      getBoxSetting({
        uid: getQueryString("uid"),
        key: getQueryString("key"),
        token: getQueryString("token"),
      }).then((res) => {
        console.log(res.data.data);
        state.wxUrl = res.data.data.wxkefuUrl;
      });
    });
    // 返回
    const onClickLeft = () => {
      router.back();
    };
    const onPhone = () => {
      console.log(state.wxUrl);
      window.location.href = state.wxUrl;
    };
    return {
      state,
      onClickLeft,
      onPhone,
    };
  },
};
</script>
<style scoped>
.service {
  /* position: fixed; */
  width: 100%;
  min-height: 100vh;
}
.content {
  background-color: #f7f8fa;
  padding-left: 32px;
  padding-right: 32px;
}
.content .title {
  font-size: 28px;
  color: #12cec7;
  margin-bottom: 28px;
}
.question-box {
  border-radius: 16px;
}
.service {
  background-color: #f7f8fa;
  /* position: fixed; */
  width: 100%;
  height: 100vh;
}

.content {
  padding: 32px;
}

.content .title {
  font-size: 28px;
  color: #12cec7;
  margin-bottom: 28px;
}

.question-box {
  border-radius: 16px;
}

.kf-box {
  /* position: fixed; */
  width: 100%;
  /* bottom: 0; */
  padding: 32px;
}

.kf-box p {
  font-size: 28px;
  text-align: center;
}

.kf-btn-box {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.kf-btn {
  /* width: 686px; */
  height: 92px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 92px;
  background-color: #12cec7;
  color: #fff;
  font-size: 32px;
  margin-left: 32px;
  margin-right: 32px;
  margin-bottom: 32px;
  margin-top: 24px;
}
.van-collapse {
  background-color: #fff;
  padding: 10px 15px;
  border-radius: 30px;
}
:deep(.van-cell) {
  background-color: #fff;
  color: #333;
}
:deep(.van-collapse-item__content) {
  background-color: #fff;
}
:deep(.van-collapse-item--border:after) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
:deep(.van-cell:after) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
</style>
